import { WithDrawActionTypes } from "./constants";

export interface WithDrawActionType {
  type:
    | WithDrawActionTypes.API_RESPONSE_SUCCESS
    | WithDrawActionTypes.API_RESPONSE_ERROR
    | WithDrawActionTypes.GET_DATA
    | WithDrawActionTypes.WITHDRAW_STATUS;

  payload: {} | string;
}

interface UpdateStatusPayload {
  id: string;
  status: string;
}

// common success
export const WithdrawApiResponseSuccess = (actionType: string, data: any | {}): WithDrawActionType => ({
  type: WithDrawActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const WithdrawApiResponseError = (actionType: string, error: string): WithDrawActionType => ({
  type: WithDrawActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getWithdrawData = (status?: string, page?: number, limit?: number): WithDrawActionType => ({
  type: WithDrawActionTypes.GET_DATA,
  payload: {
    status: status || "all",
    page: page || 1,
    limit: limit || 50,
  },
});

export const updateWithdrawStatus = ({ id, status }: UpdateStatusPayload): WithDrawActionType => ({
  type: WithDrawActionTypes.WITHDRAW_STATUS,
  payload: { id, status },
});
